/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  GetScreenRecorderFileParams,
  PaginatedScreenRecorderFiles,
  SchemaValidationErrorResponse,
  ScreenRecorderFile,
  ScreenRecorderInput
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Create File
 */
export const createScreenRecorderFile = (

 signal?: AbortSignal
) => {


      return axiosClient<ScreenRecorderFile>(
      {url: `/screen_recorder/files`, method: 'POST', signal
    },
      );
    }




export const getCreateScreenRecorderFileMutationKey = () => ['createScreenRecorderFile'] as const;

export const getCreateScreenRecorderFileMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createScreenRecorderFile>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createScreenRecorderFile>>, TError,void, TContext> => {

const mutationKey = getCreateScreenRecorderFileMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createScreenRecorderFile>>, void> = () => {


          return  createScreenRecorderFile()
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateScreenRecorderFileMutationResult = NonNullable<Awaited<ReturnType<typeof createScreenRecorderFile>>>

    export type CreateScreenRecorderFileMutationError = ErrorType<void>


    /**
 * @summary Create File
 */
export const useCreateScreenRecorderFile = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createScreenRecorderFile>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createScreenRecorderFile>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getCreateScreenRecorderFileMutationOptions(options), queryClient);
    }
    /**
 * @summary List of Files
 */
export const listScreenRecorderFiles = (

 signal?: AbortSignal
) => {


      return axiosClient<PaginatedScreenRecorderFiles>(
      {url: `/screen_recorder/files`, method: 'GET', signal
    },
      );
    }




export const getListScreenRecorderFilesQueryKey = () => {
    return [
    'screen_recorder','files'
    ] as const;
    }


export const getListScreenRecorderFilesQueryOptions = <TData = Awaited<ReturnType<typeof listScreenRecorderFiles>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listScreenRecorderFiles>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListScreenRecorderFilesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listScreenRecorderFiles>>> = ({ signal }) => listScreenRecorderFiles(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listScreenRecorderFiles>>, TError, TData>
}

export type ListScreenRecorderFilesQueryResult = NonNullable<Awaited<ReturnType<typeof listScreenRecorderFiles>>>
export type ListScreenRecorderFilesQueryError = ErrorType<void>


/**
 * @summary List of Files
 */

export function useListScreenRecorderFiles<TData = Awaited<ReturnType<typeof listScreenRecorderFiles>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listScreenRecorderFiles>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListScreenRecorderFilesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Delete File
 */
export const deleteScreenRecorderFile = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/screen_recorder/files/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteScreenRecorderFileMutationKey = () => ['deleteScreenRecorderFile'] as const;

export const getDeleteScreenRecorderFileMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteScreenRecorderFile>>, TError,DeleteScreenRecorderFileMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteScreenRecorderFile>>, TError,DeleteScreenRecorderFileMutationVariables, TContext> => {

const mutationKey = getDeleteScreenRecorderFileMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteScreenRecorderFile>>, DeleteScreenRecorderFileMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteScreenRecorderFile(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteScreenRecorderFileMutationResult = NonNullable<Awaited<ReturnType<typeof deleteScreenRecorderFile>>>

    export type DeleteScreenRecorderFileMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeleteScreenRecorderFileMutationVariables = {id: string}

    /**
 * @summary Delete File
 */
export const useDeleteScreenRecorderFile = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteScreenRecorderFile>>, TError,DeleteScreenRecorderFileMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteScreenRecorderFile>>,
        TError,
        DeleteScreenRecorderFileMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteScreenRecorderFileMutationOptions(options), queryClient);
    }
    /**
 * @summary File Details
 */
export const getScreenRecorderFile = (
    id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetScreenRecorderFileParams>,
 signal?: AbortSignal
) => {
      id = toValue(id);
params = toValue(params);

      return axiosClient<ScreenRecorderFile>(
      {url: `/screen_recorder/files/${id}`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetScreenRecorderFileQueryKey = (id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetScreenRecorderFileParams>,) => {
    return [
    'screen_recorder','files',id, ...(params ? [params] : [])
    ] as const;
    }


export const getGetScreenRecorderFileQueryOptions = <TData = Awaited<ReturnType<typeof getScreenRecorderFile>>, TError = ErrorType<void>>(id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetScreenRecorderFileParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScreenRecorderFile>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetScreenRecorderFileQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getScreenRecorderFile>>> = ({ signal }) => getScreenRecorderFile(id,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getScreenRecorderFile>>, TError, TData>
}

export type GetScreenRecorderFileQueryResult = NonNullable<Awaited<ReturnType<typeof getScreenRecorderFile>>>
export type GetScreenRecorderFileQueryError = ErrorType<void>


/**
 * @summary File Details
 */

export function useGetScreenRecorderFile<TData = Awaited<ReturnType<typeof getScreenRecorderFile>>, TError = ErrorType<void>>(
 id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetScreenRecorderFileParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScreenRecorderFile>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetScreenRecorderFileQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update File
 */
export const updateScreenRecorderFile = (
    id: MaybeRefOrGetter<string>,
    screenRecorderInput: MaybeRefOrGetter<ScreenRecorderInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
screenRecorderInput = toValue(screenRecorderInput);

      return axiosClient<ScreenRecorderFile>(
      {url: `/screen_recorder/files/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: screenRecorderInput, signal
    },
      );
    }




export const getUpdateScreenRecorderFileMutationKey = () => ['updateScreenRecorderFile'] as const;

export const getUpdateScreenRecorderFileMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateScreenRecorderFile>>, TError,UpdateScreenRecorderFileMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateScreenRecorderFile>>, TError,UpdateScreenRecorderFileMutationVariables, TContext> => {

const mutationKey = getUpdateScreenRecorderFileMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateScreenRecorderFile>>, UpdateScreenRecorderFileMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateScreenRecorderFile(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateScreenRecorderFileMutationResult = NonNullable<Awaited<ReturnType<typeof updateScreenRecorderFile>>>
    export type UpdateScreenRecorderFileMutationBody = ScreenRecorderInput
    export type UpdateScreenRecorderFileMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type UpdateScreenRecorderFileMutationVariables = {id: string;data: ScreenRecorderInput}

    /**
 * @summary Update File
 */
export const useUpdateScreenRecorderFile = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateScreenRecorderFile>>, TError,UpdateScreenRecorderFileMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateScreenRecorderFile>>,
        TError,
        UpdateScreenRecorderFileMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateScreenRecorderFileMutationOptions(options), queryClient);
    }
